import { ColumnConfig, CFAListColumnKey } from '../model';

export const listCfaConfig: Record<CFAListColumnKey, ColumnConfig> = {
  cfaName: {
    name: 'Name',
    // field: 'avatarNameStatus',
    field: 'component',
    // size: 300,
  },
  type: {
    name: 'Type',
  },
  gst: {
    name: 'GST',
    minSize: 200,
  },
  mobile: {
    name: 'Mobile Number',
  },
  cfaCode: {
    name: 'CFA Code',
    sortField: 'fulfillmentLocationCode',
  },
  city: {
    name: 'City',
  },
  state: {
    name: 'State',
  },
  pincode: {
    name: 'Pin Code',
    sortField: 'postalCode',
  },
  divisions: {
    name: 'No of Divisions',
  },
  customers: {
    name: 'No. of Customers',
  },
  options: {
    name: 'Actions',
    field: 'component',
  },
};
